import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { IPaymentCard, ISearchCard } from '@/features/cards/store/models/card.model';

import { IPagination } from '@/store/types/search.types';
import { TAppError } from '@/store/types/base.state';

import { TAgentCardAction, agentCardActionTypes, ICardAgentState } from '@/features/cards/store/types/agent-card.types';
import { CardService } from '@/features/cards/services/CardService';

export const searchAgentCards = (
  search?: ISearchCard,
): ThunkAction<Promise<void>, ICardAgentState, {}, TAgentCardAction> => {
  const request = (): TAgentCardAction => ({
    type: agentCardActionTypes.SEARCH_AGENT_CARDS,
  });
  const fail = (error: TAppError): TAgentCardAction => ({
    type: agentCardActionTypes.SEARCH_AGENT_CARDS_FAIL,
    shouldSkipToaster: true,
    error,
    documentation: 'https://docs.treezor.com/guide/cards/introduction.html#key-attributes',
  });
  const success = (cards: IPaymentCard[], pagination: IPagination): TAgentCardAction => ({
    type: agentCardActionTypes.SEARCH_AGENT_CARDS_SUCCESS,
    shouldSkipToaster: true,
    cards,
    pagination,
  });

  return async (dispatch: ThunkDispatch<{}, {}, TAgentCardAction>): Promise<void> => {
    dispatch(request());
    try {
      let cards: IPaymentCard[];

      if (search && Object.keys(search).includes('cardToken')) {
        const searchValue = search.cardToken;
        cards = [
          ...(await CardService.searchCards({ cardId: Number(searchValue) })),
          ...(await CardService.searchCards({ publicToken: searchValue.toString() })),
        ];
      } else {
        cards = await CardService.searchCards(search);
      }

      const pagination: IPagination = {
        currentPage: search?.pageNumber || 1,
        totalPages: Math.trunc((cards[0]?.totalRows || cards.length) / (search?.pageCount || 50) || 0) + 1,
      };

      dispatch(success(cards, pagination));
    } catch (error) {
      dispatch(fail(error));
    }
  };
};
